export const clientContactRoutes = [
  {
    path: 'create',
    name: 'create-client-contacts',
    component: () =>
      import(/* webpackChunkName: "new-client-contact" */ '../new-client-contact/NewClientContact.vue')
  },
  {
    path: ':id',
    name: 'client-contact-details',
    component: () =>
      import(/* webpackChunkName: "client-contact-details" */ './ClientContactDetails.vue')
  }
];
